module.exports = __webpack_public_path__ + "img/blog-bk.6f4c2711.jpg";